import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Select from 'react-select';


class LanguageSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.activeLanguage,
        };
    }

    getAbbreviation = (code) => {
        const {languageAbbreviations} = this.props;
        return languageAbbreviations[code] || "";
    };

    setValue = (selection) => {
        const {value} = this.state;
        // Don't redirect to self.
        if (selection.value !== value) {
            this.setState({
                value: selection.value,
            }, () => {
                const {languageDomains} = this.props;
                window.location = `http://${languageDomains[selection.value]}`;
            });
        }
    };

    render() {
        const options = [];
        const {languages} = this.props;
        Object.keys(languages).forEach((language) => {
            options.push({value: language, label: languages[language]});
        });

        const {value} = this.state;
        return (
            <Select
                name="language"
                value={value}
                clearable={false}
                searchable={false}
                onChange={this.setValue}
                options={options}
                valueRenderer={selection => this.getAbbreviation(selection.value)}
            />
        );
    }
}

LanguageSelector.propTypes = {
    activeLanguage: PropTypes.string.isRequired,
    languages: PropTypes.objectOf(PropTypes.string).isRequired,
    languageAbbreviations: PropTypes.objectOf(PropTypes.string).isRequired,
    languageDomains: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default LanguageSelector;
